module.exports = __webpack_public_path__ + "static/media/partner-4.bf09d8b8.png";